<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item()['postleitzahl']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item()['ort']}}</span>
  </div>
  <div class="flex flex-row">
    <span>{{item()['landeskennzeichen']}}</span>
  </div>
</div>
